exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3OeZDcBXuF18Gz27M0p7oe{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:clip;max-width:100%;vertical-align:bottom}", ""]);

// exports
exports.locals = {
	"truncatedRecipientsContainer": "_3OeZDcBXuF18Gz27M0p7oe"
};